// Provider services dashboard

import { useState, useEffect } from "react";
import {
  Home,
  LayoutGrid,
  Mail,
  Receipt,
  HelpCircle,
  LogOut,
  ChevronLeft,
  ChevronRight,
  BaggageClaim,
  ChartArea,
  Grip,
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "../../shadcn/components/ui/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import logoimage from "../../assets/image.png";
import { Button } from "../../shadcn/components/ui/Button";
import "../../App.css";
import PostTypeModal from "./Posttype";

const menuItems = [
  { icon: Home, label: "My Profile", section: "My profile" },
  {
    icon: BaggageClaim,
    label: "Post a Service/Property",
    section: "services",
  },
  {
    icon: Grip,
    label: "My Services",
    section: "MyPropertyServices",
  },
  { icon: LayoutGrid, label: "Applications", section: "application" },
  { icon: Mail, label: "Messages", section: "messages" },
  // { icon: Receipt, label: "Accounting Page", section: "accounting" },
  {
    icon: HelpCircle,
    label: "Help & Support",
    section: "Corporate Tickets",
  },
  {
    icon: ChartArea,
    label: "Industry Relations",
    section: "Industry Relations",
  },
];

export function DashboardSidebar({ isOpen, toggleSidebar }) {
  const [activeLink, setActiveLink] = useState("profile");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false); // State for the modal

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSectionClick = (section) => {
    setActiveLink(section);
    if (section === "services") {
      setIsModalOpen(true); // Open the modal when "services" is clicked
    } else {
      navigate(`/501 C3 Corporations/${section}`);
    }
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("name");
    localStorage.removeItem("userRole");
    localStorage.removeItem("countryOfBirth");
    localStorage.removeItem("birthDate");
    localStorage.removeItem("education");
    localStorage.removeItem("email");
    localStorage.removeItem("formid");
    localStorage.removeItem("phonenumber");
    localStorage.removeItem("userEmail");
    navigate("/");
  };

  return (
    <>
      <Sidebar
        className={`sidebarWidth fixed top-0 left-0 h-full z-50 transition-all duration-300 ease-in-out bg-white shadow-md ${
          isMobile ? (isOpen ? "w-64" : "w-16") : "w-64"
        } ${isMobile && !isOpen ? "items-center" : ""}`}
      >
        <SidebarContent className="h-full flex flex-col">
          <div
            className={`flex items-center gap-2 px-4 py-4 border-b ${
              isMobile && !isOpen ? "justify-center" : ""
            }`}
          >
            <div className="h-10 w-12 md:w-14 rounded-full bg-purple-100 flex-shrink-0">
              <img src={logoimage} alt="Logo" className="rounded-full" />
            </div>
            {(!isMobile || isOpen) && (
              <span className="font-semibold text-lg">Dashboard</span>
            )}
          </div>
          <SidebarGroup className="flex-grow">
            <SidebarGroupContent>
              <SidebarMenu>
                {menuItems.map((item) => (
                  <SidebarMenuItem key={item.label}>
                    <SidebarMenuButton asChild className="w-full">
                      <button
                        onClick={() => handleSectionClick(item.section)}
                        className={`flex items-center gap-2 px-4 py-2 w-full text-left hover:bg-purple-100 ${
                          activeLink === item.section ? "bg-purple-200" : ""
                        } ${isMobile && !isOpen ? "justify-center" : ""}`}
                      >
                        <item.icon className="h-5 w-5 flex-shrink-0" />
                        {(!isMobile || isOpen) && (
                          <span className="truncate">{item.label}</span>
                        )}
                      </button>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>

          <div className="mt-auto border-t">
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild className="w-full">
                  <button
                    onClick={handleLogout}
                    className={`flex items-center gap-2 px-4 py-6 w-full text-left hover:bg-purple-100 ${
                      isMobile && !isOpen ? "justify-center" : ""
                    }`}
                  >
                    <LogOut className="h-5 w-5 flex-shrink-0" />
                    {(!isMobile || isOpen) && <span>Logout</span>}
                  </button>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </div>
          {isMobile && (
            <Button
              variant="ghost"
              size="icon"
              className="absolute top-14 -right-10 bg-white shadow-md"
              onClick={toggleSidebar}
            >
              {isOpen ? (
                <ChevronLeft className="h-4 w-4" />
              ) : (
                <ChevronRight className="h-4 w-4" />
              )}
            </Button>
          )}
        </SidebarContent>
      </Sidebar>

      {/* PostType Modal */}
      {isModalOpen && (
        <PostTypeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)} // Close the modal
        />
      )}
    </>
  );
}
